import { io } from "socket.io-client";
import EventEmitter from "events";

let socket;
const botSocketEventEmitter = new EventEmitter();

const connectBotSocket = (serverUrl, userId) => {
    if (!socket) {
        if (serverUrl === "/bot") {
            socket = io("", {
                path: "/bot/socket.io/",
                query: { userId },
            });
        } else {
            socket = io(serverUrl, {
                query: { userId },
            });
        }

        socket.on("connect", () => {
            console.log("Connected to bot WebSocket server");
        });

        socket.on("disconnect", () => {
            console.log("Disconnected from bot WebSocket server");
        });

        // Add a catch-all listener to log all events from bot socket
        socket.onAny((eventName, ...args) => {
            console.log(`[BOT SOCKET EVENT] ${eventName}:`, ...args);
        });

        socket.on("request-code", (data) => {
            botSocketEventEmitter.emit("request-code", data);
        });

        socket.on("session-expired", (data) => {
            console.log("Session expired event received:", data);
            botSocketEventEmitter.emit("session-expired", data);
        });
    }

    return botSocketEventEmitter;
};

export { connectBotSocket, botSocketEventEmitter, socket };
